// extracted by mini-css-extract-plugin
module.exports = {"root":"general-article-module--root--oVIrk","title":"general-article-module--title--2YWs4 typography-module--responsiveTitle1--1tLTC"};